/**
 * Centralized API Timeout Configuration
 * 
 * Standard SLA for frontend API calls:
 * - AI generation tasks require time to think and generate complete responses
 * - Database operations should be quick
 * - We prefer complete responses over fast incomplete ones
 */

export const API_TIMEOUTS = {
    /**
     * Default timeout for all AI generation endpoints
     * 4 minutes - allows AI to generate complete, high-quality responses
     */
    AI_GENERATION: 240_000, // 4 minutes

    /**
     * Quick operations (database reads/writes, simple API calls)
     * 30 seconds - these should be fast or something is wrong
     */
    QUICK_OPERATION: 30_000, // 30 seconds

    /**
     * Complex AI tasks that may require extended processing
     * (e.g., multi-step workflows, batch processing)
     */
    EXTENDED_AI: 600_000, // 10 minutes
} as const

/**
 * Get appropriate timeout for an operation type
 */
export function getTimeout(operationType: keyof typeof API_TIMEOUTS): number {
    return API_TIMEOUTS[operationType]
}

/**
 * Default timeout to use when not specified
 */
export const DEFAULT_TIMEOUT = API_TIMEOUTS.AI_GENERATION
